"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWeatherIconSvgBySymbol = exports.symbolsLight = void 0;
// clear
var _1_svg_1 = __importDefault(require("./symbols/light/1.svg"));
// mostly clear
var _2_svg_1 = __importDefault(require("./symbols/light/2.svg"));
// overcast
var _7_svg_1 = __importDefault(require("./symbols/light/7.svg"));
// fog
var _9_svg_1 = __importDefault(require("./symbols/light/9.svg"));
// isolated showers
var _21_svg_1 = __importDefault(require("./symbols/light/21.svg"));
// scattered showers
var _24_svg_1 = __importDefault(require("./symbols/light/24.svg"));
// showers
var _27_svg_1 = __importDefault(require("./symbols/light/27.svg"));
// light rain
var _37_svg_1 = __importDefault(require("./symbols/light/37.svg"));
// moderate rain
var _38_svg_1 = __importDefault(require("./symbols/light/38.svg"));
// heavy rain
var _39_svg_1 = __importDefault(require("./symbols/light/39.svg"));
// isolated light sleet showers
var _41_svg_1 = __importDefault(require("./symbols/light/41.svg"));
// isolated moderate sleet showers
var _42_svg_1 = __importDefault(require("./symbols/light/42.svg"));
// isolated heavy sleet showers
var _43_svg_1 = __importDefault(require("./symbols/light/43.svg"));
// light sleet
var _47_svg_1 = __importDefault(require("./symbols/light/47.svg"));
// moderate sleet
var _48_svg_1 = __importDefault(require("./symbols/light/48.svg"));
// heavy sleet
var _49_svg_1 = __importDefault(require("./symbols/light/49.svg"));
// isolated light snow showers
var _51_svg_1 = __importDefault(require("./symbols/light/51.svg"));
// isolated moderate snow showers
var _52_svg_1 = __importDefault(require("./symbols/light/52.svg"));
// isolated heavy snow showers
var _53_svg_1 = __importDefault(require("./symbols/light/53.svg"));
// light snowfall
var _57_svg_1 = __importDefault(require("./symbols/light/57.svg"));
// moderate snowfall
var _58_svg_1 = __importDefault(require("./symbols/light/58.svg"));
// heavy snowfall
var _59_svg_1 = __importDefault(require("./symbols/light/59.svg"));
// isolated thundershowers
var _71_svg_1 = __importDefault(require("./symbols/light/71.svg"));
// scattered thundershowers
var _74_svg_1 = __importDefault(require("./symbols/light/74.svg"));
// thundershowers
var _77_svg_1 = __importDefault(require("./symbols/light/77.svg"));
exports.symbolsLight = {
    '1': {
        day: _1_svg_1.default
    },
    '2': {
        day: _2_svg_1.default
    },
    '21': {
        day: _21_svg_1.default
    },
    '22': {
        day: _24_svg_1.default
    },
    '23': {
        day: _27_svg_1.default
    },
    '3': {
        day: _7_svg_1.default
    },
    '31': {
        day: _37_svg_1.default
    },
    '32': {
        day: _38_svg_1.default
    },
    '33': {
        day: _39_svg_1.default
    },
    '41': {
        day: _51_svg_1.default
    },
    '42': {
        day: _52_svg_1.default
    },
    '43': {
        day: _53_svg_1.default
    },
    '51': {
        day: _57_svg_1.default
    },
    '52': {
        day: _58_svg_1.default
    },
    '53': {
        day: _59_svg_1.default
    },
    '61': {
        day: _71_svg_1.default
    },
    '62': {
        day: _74_svg_1.default
    },
    '63': {
        day: _77_svg_1.default
    },
    '64': {
        day: _77_svg_1.default
    },
    '71': {
        day: _41_svg_1.default
    },
    '72': {
        day: _42_svg_1.default
    },
    '73': {
        day: _43_svg_1.default
    },
    '81': {
        day: _47_svg_1.default
    },
    '82': {
        day: _48_svg_1.default
    },
    '83': {
        day: _49_svg_1.default
    },
    '91': {
        day: _9_svg_1.default
    },
    '92': {
        day: _9_svg_1.default
    }
};
var getWeatherIconSvgBySymbol = function (symbol) {
    var _a;
    return (_a = exports.symbolsLight[symbol]) === null || _a === void 0 ? void 0 : _a.day;
};
exports.getWeatherIconSvgBySymbol = getWeatherIconSvgBySymbol;
//# sourceMappingURL=index.js.map